// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as TermsRouteImport } from './pages/terms'
import { Route as PrivacyRouteImport } from './pages/privacy'
import { Route as PaymentSuccessRouteImport } from './pages/payment-success'
import { Route as PaymentFailRouteImport } from './pages/payment-fail'
import { Route as PaymentRouteImport } from './pages/payment'
import { Route as MypageRouteImport } from './pages/mypage'
import { Route as LoginRouteImport } from './pages/login'
import { Route as LandingRouteImport } from './pages/landing'
import { Route as IndexRouteImport } from './pages/index'
import { Route as SajuSajuTypeRouteImport } from './pages/saju.$sajuType'
import { Route as OauthCallbackRouteImport } from './pages/oauth/callback'
import { Route as SajuSajuTypeIndexRouteImport } from './pages/saju.$sajuType.index'
import { Route as SajuSajuTypeResultRouteImport } from './pages/saju.$sajuType.result'
import { Route as SajuSajuTypeResultDetailRouteImport } from './pages/saju.$sajuType.result.detail'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
            id: '/payment-success',path: '/payment-success',getParentRoute: () => rootRouteImport
          })
const PaymentFailRoute = PaymentFailRouteImport.update({
            id: '/payment-fail',path: '/payment-fail',getParentRoute: () => rootRouteImport
          })
const PaymentRoute = PaymentRouteImport.update({
            id: '/payment',path: '/payment',getParentRoute: () => rootRouteImport
          })
const MypageRoute = MypageRouteImport.update({
            id: '/mypage',path: '/mypage',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LandingRoute = LandingRouteImport.update({
            id: '/landing',path: '/landing',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SajuSajuTypeRoute = SajuSajuTypeRouteImport.update({
            id: '/saju/$sajuType',path: '/saju/$sajuType',getParentRoute: () => rootRouteImport
          })
const OauthCallbackRoute = OauthCallbackRouteImport.update({
            id: '/oauth/callback',path: '/oauth/callback',getParentRoute: () => rootRouteImport
          })
const SajuSajuTypeIndexRoute = SajuSajuTypeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SajuSajuTypeRoute
          })
const SajuSajuTypeResultRoute = SajuSajuTypeResultRouteImport.update({
            id: '/result',path: '/result',getParentRoute: () => SajuSajuTypeRoute
          })
const SajuSajuTypeResultDetailRoute = SajuSajuTypeResultDetailRouteImport.update({
            id: '/detail',path: '/detail',getParentRoute: () => SajuSajuTypeResultRoute
          })





const SajuSajuTypeResultRouteChildren = {
  SajuSajuTypeResultDetailRoute: SajuSajuTypeResultDetailRoute
}

const SajuSajuTypeResultRouteWithChildren = SajuSajuTypeResultRoute._addFileChildren(SajuSajuTypeResultRouteChildren)



const SajuSajuTypeRouteChildren = {
  SajuSajuTypeResultRoute: SajuSajuTypeResultRouteWithChildren,SajuSajuTypeIndexRoute: SajuSajuTypeIndexRoute
}

const SajuSajuTypeRouteWithChildren = SajuSajuTypeRoute._addFileChildren(SajuSajuTypeRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LandingRoute: LandingRoute,LoginRoute: LoginRoute,MypageRoute: MypageRoute,PaymentRoute: PaymentRoute,PaymentFailRoute: PaymentFailRoute,PaymentSuccessRoute: PaymentSuccessRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,OauthCallbackRoute: OauthCallbackRoute,SajuSajuTypeRoute: SajuSajuTypeRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)